import { motion } from "framer-motion";

const KolektifGenclik = () => {
  return (
    <div className="relative min-h-screen">
      {/* <div className="absolute inset-0 bg-[url('/images/blur.jpeg')] bg-cover bg-center opacity-30 pointer-events-none blur-sm"></div> */}
      <main className="relative min-h-screen bg-gradient-to-b from-[#0A0A0A]/95 via-[#111111]/95 to-[#0A0A0A]/95">
        <div className="absolute inset-0 bg-[url('/noise.png')] opacity-5 pointer-events-none"></div>

        {/* Hero Section */}
        <div className="relative h-[60vh] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/50 to-[#0A0A0A] z-10" />
          </div>

          <div className="relative z-20 text-center px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6">
                Kolektif Gençlik
              </h1>
              <p className="text-xl sm:text-2xl text-blue-300 max-w-3xl mx-auto">
                Geleceği şekillendiren gençlerin buluşma noktası
              </p>
            </motion.div>
          </div>
        </div>

        {/* Content Section */}
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="space-y-8"
            >
              <div>
                <h2 className="text-2xl font-bold text-white mb-4">
                  Biz Kimiz?
                </h2>
                <p className="text-gray-300 leading-relaxed">
                  Kolektif Gençlik, Kolektif Oluşum'un gençlik temsilciliklerini
                  ve faaliyetlerini yöneten birimdir. Gençlerin bir araya
                  gelmesini, bilgi ve deneyim paylaşımını sağlayan bir platform
                  olarak hizmet vermektedir.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-white mb-4">
                  Ne Yapıyoruz?
                </h2>
                <p className="text-gray-300 leading-relaxed">
                  Liselerde okuyan öğrencilerin bir araya gelmesini sağlayan
                  Kolektif Gençlik, gençlerin kariyer gelişimlerine katkıda
                  bulunmakta ve onları geleceğe hazırlamaktadır.
                </p>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="space-y-6"
            >
              <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors duration-300">
                <h3 className="text-xl font-semibold text-white mb-3">
                  Etkinlikler ve Atölyeler
                </h3>
                <p className="text-gray-400">
                  Düzenli olarak gerçekleştirdiğimiz etkinlikler ve atölyelerle
                  gençlerin kendilerini geliştirmelerine olanak sağlıyoruz.
                </p>
              </div>

              <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors duration-300">
                <h3 className="text-xl font-semibold text-white mb-3">
                  Networking İmkanları
                </h3>
                <p className="text-gray-400">
                  Farklı okullardan gençleri bir araya getirerek değerli
                  bağlantılar kurmalarına yardımcı oluyoruz.
                </p>
              </div>

              <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors duration-300">
                <h3 className="text-xl font-semibold text-white mb-3">
                  Kariyer Gelişimi
                </h3>
                <p className="text-gray-400">
                  Mentorluk programları ve kariyer etkinlikleriyle gençlerin
                  gelecek planlarına destek oluyoruz.
                </p>
              </div>
            </motion.div>
          </div>
        </div>

        <section className="py-24 bg-white/5">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6 }}
              className="text-center mb-16"
            >
              <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6 tracking-wide">
                Üyelik Avantajları
              </h2>
              <p className="text-lg sm:text-xl text-gray-300 max-w-3xl mx-auto">
                Kolektif Gençlik üyeleri olarak sizleri bekleyen fırsatlar
              </p>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 }}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors duration-300"
              >
                <h3 className="text-xl font-semibold text-white mb-3">
                  Proje ve Etkinlik Deneyimi
                </h3>
                <p className="text-gray-400">
                  Büyük projelerde ve etkinliklerde çalışma fırsatı
                  bulacaksınız.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors duration-300"
              >
                <h3 className="text-xl font-semibold text-white mb-3">
                  Özel İndirimler
                </h3>
                <p className="text-gray-400">
                  Hayatınızın her alanında kolaylık sağlayacak ayrıcalıklardan
                  ve indirimlerden faydalanacaksınız.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors duration-300"
              >
                <h3 className="text-xl font-semibold text-white mb-3">
                  Networking İmkanları
                </h3>
                <p className="text-gray-400">
                  Vizyoner gençlerle networking yapma ve tanışma imkânı elde
                  edeceksiniz.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors duration-300"
              >
                <h3 className="text-xl font-semibold text-white mb-3">
                  Proje Geliştirme Desteği
                </h3>
                <p className="text-gray-400">
                  Kendi projelerinizi geliştirip Kolektif Oluşum desteğiyle
                  çalışma fırsatı yakalayacaksınız.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.5 }}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors duration-300"
              >
                <h3 className="text-xl font-semibold text-white mb-3">
                  Staj Fırsatları
                </h3>
                <p className="text-gray-400">
                  Kolektif Oluşum'da staj yapma ve bu deneyimi CV'nize ekleme
                  şansına sahip olacaksınız.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.6 }}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-colors duration-300"
              >
                <h3 className="text-xl font-semibold text-white mb-3">
                  Topluluk Katkısı
                </h3>
                <p className="text-gray-400">
                  Kolektif Oluşum'un değerli bir parçası olarak büyüyen
                  topluluğa katkı sağlayacaksınız.
                </p>
              </motion.div>
            </div>
          </div>
        </section>

        <section className="py-24">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6 }}
              className="text-center mb-12"
            >
              <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6 tracking-wide">
                Başvuru Formu
              </h2>
              <p className="text-lg sm:text-xl text-gray-300 max-w-3xl mx-auto">
                Kolektif Gençlik ailesine katılmak için aşağıdaki formu
                doldurabilirsiniz.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="max-w-4xl mx-auto rounded-2xl overflow-hidden bg-white/5 backdrop-blur-sm border border-white/10 shadow-2xl"
            >
              <div className="p-2">
                <iframe
                  src="https://docs.google.com/forms/d/e/1FAIpQLSfLyL1ckRAuIMCkB_GKox0juDZHvNx8Mwh0VaW-vruQoezl0w/viewform?embedded=true"
                  className="w-full h-[800px] md:h-[700px]"
                  loading="lazy"
                >
                  Yükleniyor...
                </iframe>
              </div>
            </motion.div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default KolektifGenclik;
